define('hierarchicalrefinmentlist',["instantsearch", "jquery", "mustache", "algoliasearch", "algoliasearchhelper", "eventManager"],
    function (instantsearch, $, mustache, algoliasearch, algoliasearchhelper, eventManager) {
        instantsearch.widgets.hierarchicalRefinmentList = function hierarchicalRefinmentList(options, algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage, languageFacet) {
      
            var configOptions = options;			
			var hierarchicalFacets = options.attributes;			
			var resultsHelper = null;
			var selectedRefinements = [];						
			var container = document.querySelector(options.container);						
			var client = algoliasearch(algoliaApplicationId, algoliaApiKey);			
			var hierarchicalFacetHelper = algoliasearchhelper(client, algoliaIndexName, {
			    facets: [hierarchicalFacets[0], hierarchicalFacets[1], languageFacet],
				facetsRefinements: {
                        _language: [contextLanguage]
                    }
			});		
			var initialHierarchicalFacets = [];			
			
			hierarchicalFacetHelper.on('result', function(data){
				
				if (initialHierarchicalFacets.length === 0) {
					var levelOneFacet = data.facets[0].data;
					var levelTwoFacet = data.facets[1].data;
					
					if (hierarchicalFacets[0] === data.facets[0].name || hierarchicalFacets[1] === data.facets[1].name) {
						for (var firstLevelFacetName in levelOneFacet) {						
							var indexInResult = $.inArray(firstLevelFacetName, initialHierarchicalFacets);
							var firstLevelFacet = {
								name: firstLevelFacetName,
								count: levelOneFacet[firstLevelFacetName],
								itemClass: configOptions.cssClasses.item,							
								listClass: configOptions.cssClasses.list,
								countClass: configOptions.cssClasses.count,
								nameClass: configOptions.cssClasses.name,
								checked: false,
								data: null
							}
							
							if (indexInResult === -1)
							{	
								var secondLevelChildren = [];
								
								for (var secondLevelFacetName in levelTwoFacet) {								
									if (firstLevelFacet.data === null && secondLevelFacetName.startsWith(firstLevelFacetName + " " + configOptions.operator + " ")) {
										
										var secondIndexInResult = $.inArray(secondLevelFacetName, secondLevelChildren);
										
										if (secondIndexInResult === -1)
										{					
											var secondLevelFacet = {
												name: secondLevelFacetName,
												count: levelTwoFacet[secondLevelFacetName],										
												itemClass: configOptions.cssClasses.secondLvlItem,
												listClass: configOptions.cssClasses.list,
												countClass: configOptions.cssClasses.count,
												nameClass: configOptions.cssClasses.name,
												checked: false
											}								
											
											secondLevelChildren.push(secondLevelFacet);								
										}																					
									}
								}
								firstLevelFacet.data = secondLevelChildren;
								initialHierarchicalFacets.push(firstLevelFacet);							
							}
						}						
					}															
				}
				
			    //search is done from hierarchicalFacetHelper render event to avoid racing condition with resultsHelper render events
				if (resultsHelper != null) {
					resultsHelper.clearRefinements(hierarchicalFacets[0]);
					resultsHelper.clearRefinements(hierarchicalFacets[1]);
					Object.keys(selectedRefinements).map(function (key) { 						
						if ($.inArray(key, hierarchicalFacets) > -1) {
							$(selectedRefinements[key]).each(function( index ) {
								resultsHelper.toggleFacetRefinement(key, selectedRefinements[key][index]);
							});														
						}											
					});					

					resultsHelper.search();
					eventManager.trigger("SearchFiltersUpdated");
				}

			});		

			hierarchicalFacetHelper.search();

			eventManager.subscribe("ToggleSearchFilter", function (data) {
			    if ($.inArray(data.facetName, hierarchicalFacets) > -1) {
			        var $listItem = $(container).find('li[data-hierarchicalname="' + data.value + '"]');
			        var level = hierarchicalFacets[0] === data.facetName ? 0 : 1;

			        if ($listItem) {
			            itemClickEventHandler($listItem, level);
			        };
			    }
				else {
					selectedRefinements = hierarchicalFacetHelper.state.facetsRefinements;
					hierarchicalFacetHelper.search();
				};
			});
			
			mapAndRenderReturnedFacets: function mapAndRenderReturnedFacets(levelFacet, level, results) {				
				var html = "<ul class='" + configOptions.cssClasses.list + "'>";
				var counter = 0;
				initialHierarchicalFacets.sort(function (a, b) {
				    var nameA = a.name.toUpperCase();
				    var nameB = b.name.toUpperCase();
				    if (nameA < nameB) {
				        return -1;
				    }
				    if (nameA > nameB) {
				        return 1;
				    }
				    return 0;
				});

				initialHierarchicalFacets.map(function(initialLevelFacet) {					
					html += mapAndRenderLevel(initialLevelFacet, 0, results, counter++);
				});	
				
				html += "</ul>";				
				
				return html;
			};
			
			mapAndRenderLevel: function mapAndRenderLevel(levelFacet, level, results, counter) {
				
				var hierarchicalFacetNames = $(results.facets).map(function (index,item){
					return item.name;
				});	
				var hierarchicalFacetIndex = $.inArray(hierarchicalFacets[level], hierarchicalFacetNames);
				var indexInResult = -1;
				var returnedFacetValues = [];

				if (hierarchicalFacetIndex > -1) {
					returnedFacetValues = results.getFacetValues(hierarchicalFacets[level], null);
					var returnedFacetNames = $(returnedFacetValues).map(function (index,item){
						return item.name;
					});						
					indexInResult = $.inArray(levelFacet.name, returnedFacetNames);
				}
				
				var finalFacetValue = {};
				var itemClass = level === 0 ? configOptions.cssClasses.item : configOptions.cssClasses.secondLvlItem;				
				
				if (indexInResult === -1)
				{													
					finalFacetValue = levelFacet;
					finalFacetValue.itemClass = itemClass + ' disabled';
					finalFacetValue.count = 0;
					finalFacetValue.disabled = true;
				}							
				else
				{
					finalFacetValue = returnedFacetValues[indexInResult];
					finalFacetValue.itemClass = itemClass;
					finalFacetValue.disabled = finalFacetValue.count <= 0;
				}							
				
				finalFacetValue.id = 'h-' + level + '-' + counter;
				finalFacetValue.hierarchicalName = finalFacetValue.name;
				finalFacetValue.displayName = level === 1 ? finalFacetValue.name.substring(finalFacetValue.name.indexOf(configOptions.operator) + 2) : finalFacetValue.name;
				finalFacetValue.listClass = configOptions.cssClasses.list;
				finalFacetValue.countClass = configOptions.cssClasses.count;
				finalFacetValue.nameClass = configOptions.cssClasses.name;	
				var selectedRefinementNames = [];
				Object.keys(selectedRefinements).map(function (key) { 
					$(selectedRefinements[key]).each(function( index ) {
						selectedRefinementNames.push(selectedRefinements[key][index]);
					});										
				});					
								
				finalFacetValue.checked = $.inArray(finalFacetValue.hierarchicalName, selectedRefinementNames) > -1;
				var html  = "";												
				if (levelFacet.data && levelFacet.data.length > 0 && finalFacetValue.checked){
					var subItemsMarkup = "<ul class='" + configOptions.cssClasses.list + "'>";					
					levelFacet.data.map(function (item){
						subItemsMarkup += mapAndRenderLevel(item, level + 1, results, counter);
					});
				    subItemsMarkup += "</ul>";
					html += mustache.render("<li class='{{itemClass}}' data-hierarchicalname='{{hierarchicalName}}'><input type='checkbox' id='{{id}}' {{#checked}}checked{{/checked}} {{#disabled}}disabled='disabled'{{/disabled}}/> <label class='{{nameClass}}' for='{{id}}'>{{displayName}}</label><span class='{{countClass}}'>{{count}}</span>" + subItemsMarkup + "</li>", finalFacetValue);						
				}									
				else {
					html += mustache.render("<li class='{{itemClass}}' data-hierarchicalname='{{hierarchicalName}}'><input type='checkbox' id='{{id}}' {{#checked}}checked{{/checked}} {{#disabled}}disabled='disabled'{{/disabled}}/> <label class='{{nameClass}}' for='{{id}}'>{{displayName}}</label><span class='{{countClass}}'>{{count}}</span></li>", finalFacetValue);					  						
				}	
				
				return html;
			};
			
			cancelBubble = function cancelBubble(e) {
				var evt = e ? e:window.event;
				if (evt.stopPropagation)    evt.stopPropagation();
				if (evt.cancelBubble!=null) evt.cancelBubble = true;
			};
			
			itemClickEvent = function(that, e, helper, level) {
				cancelBubble(e);

				itemClickEventHandler(that, level);

				return false;
			};
			
			itemClickEventHandler = function(that, level) {
				var $relatedCheckBox = $(that).find('input[type="checkbox"]').filter(':first');
				
				if ($relatedCheckBox.is('[disabled=disabled]') && !$relatedCheckBox.prop("checked")) {
					return false;
				}						
				
				hierarchicalFacetHelper.state.facetsRefinements = selectedRefinements;

                //uncheck level 1 children and updated facets
				if (level === 0 && $relatedCheckBox.prop("checked")) {
					var childrenCheckboxes = $(that).find('ul input[type="checkbox"]');
					
					$(childrenCheckboxes).map(function (index, item) {
						if ($(item).prop("checked")) {
							toggleCheckBoxAndUpdateFacet($(item), $(item).parent(), 1, false);
						}					    
					});

					selectedRefinements = hierarchicalFacetHelper.state.facetsRefinements;
				}

				toggleCheckBoxAndUpdateFacet($relatedCheckBox, $(that), level, !$relatedCheckBox.prop("checked"));

				hierarchicalFacetHelper.search();				
			};

			toggleCheckBoxAndUpdateFacet = function ($relatedCheckBox, $parentItem, level, checkState) {
			    $relatedCheckBox.prop("checked", checkState);

                var facetValue = $parentItem.data('hierarchicalname');

                hierarchicalFacetHelper.toggleFacetRefinement(hierarchicalFacets[level], facetValue);
                selectedRefinements = hierarchicalFacetHelper.state.facetsRefinements;
            };

            return {
                // Method called at startup, to configure the Algolia settings
                getConfiguration: function getConfiguration(currentConfiguration) {									
                    return {
						facets: configOptions.attributes
                    };					
                },

                // Called on the first instantsearch search
                init: function init(options) {	
					var helper = options.helper;				
					selectedRefinements = helper.state.facetsRefinements;
                },

                // Called whenever we receive new results from Algolia
                render: function render(options) {					
					var helper = options.helper;										
										
					var html = mapAndRenderReturnedFacets(hierarchicalFacets[0], 0, options.results);					                     
					
					$(container).html(html);
					
					var $firstLvlItemElements = $(container).find('.' + configOptions.cssClasses.item);
					
					$firstLvlItemElements.on('click', function(e){						
						return itemClickEvent(this, e, helper, 0);
					});	

					var $secondLvlItemElements = $(container).find('.' + configOptions.cssClasses.secondLvlItem);					
										
					$secondLvlItemElements.on('click', function(e){						
						return itemClickEvent(this, e, helper, 1);
					});																		
										
					resultsHelper = options.helper;					
                },
				clearAll: function clearAll() {
					resultsHelper.clearRefinements(hierarchicalFacets[0]);
					resultsHelper.clearRefinements(hierarchicalFacets[1]);						
					hierarchicalFacetHelper.clearRefinements(hierarchicalFacets[0]);
					hierarchicalFacetHelper.clearRefinements(hierarchicalFacets[1]);
					selectedRefinements = hierarchicalFacetHelper.state.facetsRefinements;
					hierarchicalFacetHelper.search();
				}
            }
        };
    });
